import type { BlockImage } from 'types/block-image';
import React from 'react';
import Figure from './figure';
import WysiwygContent from './wysiwyg-content';
import Rating from './rating';

const Image: React.FC<BlockImage> = ({
  image,
  description,
  ratingStars,
  roundedCorners,
  descriptionPosition,
  largerParagraph,
}) => {
  const isOutside = descriptionPosition === 'outside';
  return (
    <section
      className={[
        'w-full px-5 lg:px-10 mx-auto py-0 lg:py-12 max-w-screen-2xl relative',
        isOutside ? 'grid grid-cols-5 gap-y-5' : '',
      ].join(' ')}
    >
      <Figure
        {...image}
        className={[
          roundedCorners ? 'rounded-lg' : '',
          isOutside ? 'col-span-full' : '',
        ].join(' ')}
      />
      {description?.length > 0 && (
        <WysiwygContent
          content={description}
          largerParagraph={largerParagraph}
          className={[
            isOutside
              ? 'col-span-full md:col-span-2'
              : 'absolute top-4 left-8 lg:top-20 lg:left-20 max-w-56 md:max-w-100',
          ].join(' ')}
        />
      )}
      {(ratingStars !== null || ratingStars > 0) && (
        <Rating
          rating={ratingStars.toString()}
          highlightColor="#FFFFFF"
          bgColor="#FFFFFF"
          showTotalStars={true}
          className="absolute bottom-4 left-8 lg:bottom-20 lg:left-20"
          starsVariant="large"
        />
      )}
    </section>
  );
};

export default Image;
